// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2S1iv","additionalInfo":"AgreementModal_additionalInfo__TDCTF"};